import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJAIImageList from '../view/FJAIImageList.jsx';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionAiHistoryCommon from '../../../../redux/action/FJActionAiHistoryCommon.js';
import FJConfig from '../../../../config/FJConfig.js';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';
const FJAIImageListContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const aiTextToImageHistoryList = useSelector(state => state.aiHistoryCommon.aiTextToImageHistoryList);
    const aiTextToImageHistoryLoadStatus = useSelector(state => state.aiHistoryCommon.aiTextToImageHistoryLoadStatus);
    const aiImageToImageHistoryList = useSelector(state => state.aiHistoryCommon.aiImageToImageHistoryList);
    const aiImageToImageHistoryLoadStatus = useSelector(state => state.aiHistoryCommon.aiImageToImageHistoryLoadStatus);

    const active = useSelector(state => state.aiHistoryCommon.isShowAIImageHistoryModal);

    const closeModal = useCallback(() => {
        dispatch(FJActionAiHistoryCommon.setIsShowAIImageHistoryModalAction(false));
    }, [dispatch]);

    const itemClick = useCallback((info, curMenuIndex) => {
        switch (FJConfig.appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR:
                dispatch(FJActionAIVideoGenerator.useAIImageAction(info, curMenuIndex));
                break;
            default:
        }
    }, []);

    const onTextToImageHistoryRetry = () => {
        dispatch(FJActionAiHistoryCommon.initAiTextToImageHistoryList());
    };

    const onImageToImageHistoryRetry = () => {
        dispatch(FJActionAiHistoryCommon.initAiImageToImageHistoryList());
    };

    return (
        <FJAIImageList
            active={active}
            closeModal={closeModal}
            aiTextToImageHistoryList={aiTextToImageHistoryList}
            aiTextToImageHistoryLoadStatus={aiTextToImageHistoryLoadStatus}
            aiImageToImageHistoryList={aiImageToImageHistoryList}
            aiImageToImageHistoryLoadStatus={aiImageToImageHistoryLoadStatus}
            onTextToImageHistoryRetry={onTextToImageHistoryRetry}
            onImageToImageHistoryRetry={onImageToImageHistoryRetry}
            itemClick={itemClick}
        />
    );
};
FJAIImageListContainer.propTypes = {
    active: PropTypes.bool,
    closeModal: PropTypes.func,
};

export default FJAIImageListContainer;
